<script lang="ts" setup>
defineEmits(['change']);

const props = defineProps<{
  rating: number;
  editable?: boolean;
  size?: string;
}>();

const editableRating = ref(props.rating || 0);
const roundedRating = computed(() => Number(props.rating.toFixed()));
</script>

<template>
  <div class="rating">
    <span
      v-for="n in 5"
      :key="n"
      class="rating__icon"
      @click="$emit('change', editableRating)"
      @mouseout="editableRating = rating"
      @mouseover="editableRating = 6 - n"
    >
      <SvgoStar
        :class="[
          6 - (editable ? editableRating : roundedRating) <= n ? 'text-black' : 'text-black-20',
          `size-${size ?? '4'}`,
        ]"
        :font-controlled="false"
        filled
      />
    </span>
  </div>
</template>

<style lang="scss" scoped>
.rating {
  display: flex;
  align-items: center;
  unicode-bidi: bidi-override;
  direction: rtl;

  &__icon {
    padding-right: 0.125rem;
    padding-left: 0.125rem;
  }
}
</style>
